import { Component, OnInit } from '@angular/core';

import { MultiplyCalcComponent } from './multiply-calc.component';
import { ExerciseStarterComponent } from '../exercise-starter/exercise-starter.component';

@Component({
  selector: 'app-multiply',
  templateUrl: './multiply.component.html',
  styleUrls: ['./multiply.component.css']
})
export class MultiplyComponent implements OnInit {
  title = 'Øv dig i at gange';
  mLevel: number = 0;
  mState = '';
  mPoints = 0;
  mCalcState = 'false'
 
  
  constructor() {
  }
  
  ngOnInit() {
    this.mState = 'init'
  }  

  setState(val: string) {
    this.mCalcState = 'true';
  }
    
  setPoints(val: number) {
    this.mState = 'tryAgain';
    this.mPoints = val;    
    this.mCalcState = 'false';
  }
    
  setLevel(newLevel: number)
  {
    if (newLevel && this.mLevel != newLevel)
    {
      this.mLevel = newLevel;
    }
  }

}



// WEBPACK FOOTER //
// /home/hkk/source/crazyaboutmath/src/app/multiply/multiply.component.ts